import * as React from 'react';
export default function SvgMergeTags() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.504 5a.75.75 0 0 0-.52.21L4.717 10.27a2.337 2.337 0 0 0-.084 3.284l3.49 3.716a2.337 2.337 0 0 0 3.349.056l5.313-5.294a.75.75 0 0 0 .221-.531V5.75a.75.75 0 0 0-.75-.75h-5.752Zm-4.747 6.353L10.806 6.5h4.7v4.69l-5.092 5.073a.837.837 0 0 1-1.199-.02l-3.488-3.714a.837.837 0 0 1 .03-1.176Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.938 8.285a.75.75 0 0 0-1.5 0v4.155l-5.642 5.623a.75.75 0 0 0 1.058 1.062l5.863-5.842a.75.75 0 0 0 .221-.531V8.285Z",
    fill: "currentColor"
  }));
}